// extracted by mini-css-extract-plugin
export default {"challengeScroll":"ChallengePage_challengeScroll__E2Ows","closeButton":"ChallengePage_closeButton__ygsn+","loaderContainer":"ChallengePage_loaderContainer__rNyN+"};